import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('networkPointSearchService', networkPointSearchService);

    function networkPointSearchService(NETWORK_POINT_SEARCH_MODE) {
        var BROADCAST = {
            CANCEL: 'cancelNetworkPointSearch'
        };
        /**
         * The input field of the network point search can have icons such as a magnifier or a quick filter button.
         * The fault is <tt>NONE</tt>.
         *
         * @type {{MAGNIFIER: string, QUICK_FILTER: string, NONE: string}}
         */
        var INPUT_ADDON = {
            MAGNIFIER: 'MAGNIFIER',
            QUICK_FILTER: 'QUICK_FILTER',
            NONE: 'NONE'
        };

        /**
         * The input field of the network point search can a detail level.
         */
        var DETAIL_LEVEL = {
            MINIMAL: 'MINIMAL',
            INIT_GRAPH: 'INIT_GRAPH',
            INIT_ACTIONS: 'INIT_ACTIONS',
            INIT_ACTIONS_AND_GRAPH: 'INIT_ACTIONS_AND_GRAPH'
        };

        var BUNDLE_TYPE = {
            ALL: 'ALL',
            BUNDLED: 'BUNDLED',
            UNBUNDLED: 'UNBUNDLED'
        };

        return {
            BROADCAST: BROADCAST,
            INPUT_ADDON: INPUT_ADDON,
            DETAIL_LEVEL: DETAIL_LEVEL,
            BUNDLE_TYPE: BUNDLE_TYPE,
            mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints:
                mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints,
            populateSuggestionsWithModelAttribute:
                populateSuggestionsWithModelAttribute,
            getSelectedNetworkPoints: getSelectedNetworkPoints,
            removeCheckedFlagAddFavoriteFlag: removeCheckedFlagAddFavoriteFlag,
            defaultModeAttr: defaultModeAttr,
            defaultInputAddonAttr: defaultInputAddonAttr,
            defaultDetailLevelAttr: defaultDetailLevelAttr,
            addCheckedFlag: addCheckedFlag,
            widthOfScrollbar: widthOfScrollbar
        };

        /**
         * Merges the favorite and non-favorite network points to one array.
         *
         * @param {boolean} showFavoritesOnly If false, non-favorites will be merged.
         * @param {boolean} separateFavorites If true, favorites will be merged.
         * @param {Array|null} preSelected Will be merged if present.
         * @param {Array} suggestions Non-favorite suggested network points.
         * @param {Array} favoriteSuggestions  Favorite suggested network points.
         * @returns {Array} The merged network points
         */
        function mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints(
            showFavoritesOnly,
            separateFavorites,
            preSelected,
            suggestions,
            favoriteSuggestions
        ) {
            var mergedNetworkPoints = [];

            if (!showFavoritesOnly) {
                var i;
                for (i = 0; i < suggestions.length; i++) {
                    mergedNetworkPoints.push(suggestions[i]);
                }
            }

            if (separateFavorites) {
                var k;
                for (k = 0; k < favoriteSuggestions.length; k++) {
                    mergedNetworkPoints.push(favoriteSuggestions[k]);
                }
            }

            if (preSelected) {
                var j;
                for (j = 0; j < preSelected.length; j++) {
                    mergedNetworkPoints.push(preSelected[j]);
                }
            }

            return mergedNetworkPoints;
        }

        /**
         * Will populate suggestions with an attribute <tt>_checked</tt> that serves as the ngModel-bound value.
         * Will apply to all network points as they are merged in
         * {@link mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints}.
         *
         * @param {boolean} showFavoritesOnly
         * @param {boolean} separateFavorites
         * @param {Array|null} preSelected
         * @param {Array} suggestions
         * @param {Array} favoriteSuggestions
         */
        function populateSuggestionsWithModelAttribute(
            showFavoritesOnly,
            separateFavorites,
            preSelected,
            suggestions,
            favoriteSuggestions
        ) {
            var networkPoints =
                mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints(
                    showFavoritesOnly,
                    separateFavorites,
                    preSelected,
                    suggestions,
                    favoriteSuggestions
                );

            var i;
            for (i = 0; i < networkPoints.length; i++) {
                networkPoints[i]._checked = isNetworkPointPreselected(
                    networkPoints[i],
                    preSelected
                );
            }

            return networkPoints;
        }

        /**
         * Check if a network point is pre-selected.
         *
         * @param {Array} networkPoint
         * @param {Array} preSelected
         * @returns {boolean}
         */
        function isNetworkPointPreselected(networkPoint, preSelected) {
            if (!preSelected) {
                return false;
            }

            var i;
            for (i = 0; i < preSelected.length; i++) {
                if (
                    networkPoint.id === preSelected[i].id &&
                    networkPoint._checked
                ) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Get selected network points stripping the <tt>._checked</tt> attribute.
         *
         * @returns {Array} Objects of network points that are selected.
         */
        function getSelectedNetworkPoints(
            showFavoritesOnly,
            separateFavorites,
            preSelected,
            suggestions,
            favoriteSuggestions
        ) {
            var networkPoints =
                mergeFavoriteAndNonFavoriteAndPreselectedNetworkPoints(
                    showFavoritesOnly,
                    separateFavorites,
                    preSelected,
                    suggestions,
                    favoriteSuggestions
                );
            var selectedNetworkPoints = [];
            var tmpNetworkPointCopy;

            var i;
            for (i = 0; i < networkPoints.length; i++) {
                if (networkPoints[i]._checked === true) {
                    tmpNetworkPointCopy = angular.copy(networkPoints[i]);
                    delete tmpNetworkPointCopy._checked;
                    selectedNetworkPoints.push(tmpNetworkPointCopy);
                }
            }

            return selectedNetworkPoints;
        }

        /**
         * Delete the <tt>_checked</tt> attribute from network point and add <tt>_favorite</tt> a favorite attribute.
         *
         * @param {Object} networkPoint
         * @param {boolean} favoriteFlag True if it's favorite, false otherwise.
         * @returns {Object} Network point.
         */
        function removeCheckedFlagAddFavoriteFlag(networkPoint, favoriteFlag) {
            var tmpNetworkPoint = angular.copy(networkPoint);
            delete tmpNetworkPoint._checked;
            tmpNetworkPoint._favorite = favoriteFlag;
            return tmpNetworkPoint;
        }

        /**
         * Check if mode is valid from the {@link NETWORK_POINT_SEARCH_MODE} constant and if not make it the default.
         *
         * @param {String} mode String from constant {@link NETWORK_POINT_SEARCH_MODE} that was passed on
         *  as a directive parameter.
         * @returns {String}
         */
        function defaultModeAttr(mode) {
            if (
                angular.isUndefined(mode) ||
                !NETWORK_POINT_SEARCH_MODE.hasOwnProperty(mode)
            ) {
                mode = NETWORK_POINT_SEARCH_MODE.DEFAULT;
            }
            return mode;
        }

        /**
         * Check if input addon is valid from the {@link INPUT_ADDON} constant and if not make it the default (NONE).
         *
         * @param {String} inputAddon String from constant {@link INPUT_ADDON} that was passed on
         *  as a directive parameter.
         * @returns {String}
         */
        function defaultInputAddonAttr(inputAddon) {
            if (
                angular.isUndefined(inputAddon) ||
                !INPUT_ADDON.hasOwnProperty(inputAddon)
            ) {
                inputAddon = INPUT_ADDON.NONE;
            }
            return inputAddon;
        }

        /**
         * Check if the detail level is valid from the {@link DETAIL_LEVEL} constant and if not make it the default (MINIMAL).
         *
         * @param {String} detailLevel String from constant {@link DETAIL_LEVEL} that was passed on
         *  as a directive parameter.
         * @returns {String}
         */
        function defaultDetailLevelAttr(defaultDetailLevel) {
            if (
                angular.isUndefined(defaultDetailLevel) ||
                !INPUT_ADDON.hasOwnProperty(defaultDetailLevel)
            ) {
                defaultDetailLevel = DETAIL_LEVEL.MINIMAL;
            }
            return defaultDetailLevel;
        }

        /**
         * Add <tt>_checked</tt> attribute to the network point object.
         *
         * @param {Object} networkPoints The network point to add the flag to.
         * @param {boolean} checkedFlag Value of the attribute to be added.
         * @returns {Object} The network point with the flag.
         */
        function addCheckedFlag(networkPoints, checkedFlag) {
            for (var i = 0; i < networkPoints.length; i++) {
                networkPoints[i]._checked = checkedFlag;
            }
            return networkPoints;
        }

        /**
         * Get the width of the scrollbar of the browser.
         * This is useful when you need to adjust elements according to scrollbar width.
         *
         * @see http://www.alexandre-gomes.com/?p=115
         * @returns {number} The width in pixels of the scrollbar
         */
        function widthOfScrollbar() {
            var inner = document.createElement('p');
            inner.style.width = '100%';
            inner.style.height = '200px';

            var outer = document.createElement('div');
            outer.style.position = 'absolute';
            outer.style.top = '0px';
            outer.style.left = '0px';
            outer.style.visibility = 'hidden';
            outer.style.width = '200px';
            outer.style.height = '150px';
            outer.style.overflow = 'hidden';
            outer.appendChild(inner);

            document.body.appendChild(outer);
            var w1 = inner.offsetWidth;
            outer.style.overflow = 'scroll';
            var w2 = inner.offsetWidth;
            if (w1 == w2) {
                w2 = outer.clientWidth;
            }

            document.body.removeChild(outer);

            return w1 - w2;
        }
    }
})();
